import { Chat, Recreation } from '@/types';
import { prettyHM } from '@/utils';
import React, { FC, JSX } from 'react';

const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png'];

const isImageFile = (filename: string): boolean =>
  IMAGE_EXTENSIONS.some((ext) => filename.toLowerCase().endsWith(ext));

const replaceNewLineWithBr = (text: string): JSX.Element[] =>
  text.split('\n').map((line, i) => (
    <div key={i}>
      {line}
      <br />
    </div>
  ));

const FacilityChat: FC<{
  chat: Chat;
}> = ({ chat }) => {
  return (
    <>
      {chat.message && (
        <div className='row justify-content-end pt-2'>
          <div className='col-auto align-self-end time'>
            {prettyHM(chat.createdAt)}
          </div>
          {/* TODO(okubo): linkあればlink化する */}
          <div className='col-md-auto customer-text'>
            {replaceNewLineWithBr(chat.message)}
          </div>
        </div>
      )}
      {chat.fileUrl !== null && (
        <div className='row justify-content-end pt-1'>
          <div className='col-auto align-self-end time'>
            {prettyHM(chat.createdAt)}
          </div>
          <div className='col-md-auto customer-text'>
            {isImageFile(chat.filename) ? (
              <a href={chat.fileUrl} target='_blank' rel='noopener noreferrer'>
                <img src={chat.fileUrl} alt={chat.filename} style={{ maxWidth: '200px' }} />
              </a>
            ) : (
              <a
                href={chat.fileUrl}
                className='text-black'
                target='_blank'
                rel='noopener noreferrer'
              >
                {chat.filename}
              </a>
            )}
          </div>
        </div>
      )}
    </>
  );
};

const FileItem: FC<{
  chat: Chat;
  recreation: Recreation;
}> = ({ chat, recreation }) => {
  return (
    <div className='row justify-content-start instructor pt-2'>
      <div className='col-auto align-self-start image pe-0'>
        <img src={recreation.profile?.image} />
      </div>
      <div className='col-md-auto'>
        <div className='name'>{recreation.profile?.name}</div>
        <div className=' text'>
          {isImageFile(chat.filename) ? (
            <a href={chat.fileUrl} target='_blank' rel='noopener noreferrer'>
              <img src={chat.fileUrl} alt={chat.filename} style={{ maxWidth: '200px' }} />
            </a>
          ) : (
            <a
              href={chat.fileUrl}
              className='text-black'
              target='_blank'
              rel='noopener noreferrer'
            >
              {chat.filename}
            </a>
          )}
        </div>
      </div>
      <div className='col-auto align-self-end time'>
        {prettyHM(chat.createdAt)}
      </div>
    </div>
  );
};

const PartnerChat: FC<{
  recreation: Recreation;
  chat: Chat;
}> = ({ recreation, chat }) => {
  return (
    <>
      {chat.message && (
        <div className='row justify-content-start instructor pt-2'>
          <div className='col-auto align-self-start image pe-0'>
            <img src={recreation.profile?.image} />
          </div>
          <div className='col-md-auto'>
            {recreation.isUserDeleted ? (
              <div className='name'>削除済み講師</div>
            ) : <div className='name'>{recreation.profile?.name}</div> }
            <div className=' text'>
              {/* TODO(okubo): linkあればlink化する */}
              {replaceNewLineWithBr(chat.message)}
            </div>
          </div>
          <div className='col-auto align-self-end time'>
            {prettyHM(chat.createdAt)}
          </div>
        </div>
      )}
      {chat.fileUrl !== null && (
        <FileItem key={chat.id} chat={chat} recreation={recreation} />
      )}
    </>
  );
};

export const ChatItem: FC<{
  recreation: Recreation;
  date: string;
  chats: Chat[];
}> = ({ recreation, chats, date }) => {
  return (
    <>
      <div className='row justify-content-center pt-2'>
        <div className='col-auto date'>{date}</div>
      </div>
      {chats?.map((chat, i) => (
        <div key={i}>
          {chat.sender === 'company' ? (
            <FacilityChat chat={chat} />
          ) : (
            <PartnerChat recreation={recreation} chat={chat} />
          )}
        </div>
      ))}
    </>
  );
};
